"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DebtorTable_1 = require("./components/DebtorTable/DebtorTable");
var IndexDebtors = function () {
    return (React.createElement("div", null,
        React.createElement(DebtorTable_1.default, null)));
};
exports.default = IndexDebtors;
